export default __webpack_public_path__ + "static/media/contact-background-mobile@2x.d6f1c4ab.jpg";